import { Templates, Components } from 'angular-formio';
import { Portuguese } from 'flatpickr/dist/l10n/pt';
import * as uuid from 'node_modules/uuid';
import toHtml from 'string-to-html';
import CSSOM from 'cssom';
import moment from 'formiojs/node_modules/moment';
import { templateJitUrl } from '@angular/compiler';


// tslint:disable
export class PsTemplates {
  public setComponents() {
    const createWidget = Components.components.datetime.prototype.createWidget;
    Components.components.datetime.prototype.createWidget = function(index) {
      this.component.widget.locale = Portuguese;
      this.component.widget.time_24hr = true;
      this.component.widget.disableMobile = true;
      // this.component.widget.dateFormat = this.component.widget.format;
      // this.component.widget.altFormat = 'yyyy-MM-ddTHH:mm:ssZ';
      // this.component.widget.altInput = true;
      // this.component.widget.allowInput = false;
      // this.component.widget.inline = true;
      return createWidget.call(this, index);
    };
  }
  
  setContainerCustomCss(ctx, id) {
    let template = '';
    if (
       this.haveContainerCss(ctx.component)
       ) {
      const rules = CSSOM.parse(ctx.component.container_css);
      this.formatCssRules(rules, id);
      template += `<style>${rules.toString()}</style>`;
    }
    return template
  }

  private formatCssRules(rules, id) {
    rules.cssRules.forEach(rule => {
      if(rule.selectorText) {
        rule.selectorText = this.scopeFieldSetCssRules(rule, id);
      }
      if(rule.media) {
        this.formatCssRules(rule, id);
      }
    });
  }

  scopeFieldSetCssRules(rule, id) {
    const selectors = rule.selectorText.split(',');
    let selectorText = '';
    selectors.forEach((selector, i) => {
        return selectorText += '.fieldset' + id.split('-')[0]+ ' ' + selector + ',';
    });
    selectorText = selectorText.substring(0,(selectorText.length - 1));
    return selectorText;
  }

  haveContainerCss(container) {
    return container.container_css !== null && container.container_css !== '' && container.container_css !== undefined
  }

  setFieldSetStyleAttribute(container) {
    let styleAttribute = 'style="';
    styleAttribute += this.setContainerBackground(container);
    styleAttribute += this.setContainerWidth(container);
    styleAttribute += this.setContainerPadding(container);
    styleAttribute += '"';
    return  styleAttribute;
  }

  setContainerBackground(container) {
    if (container.container_background_type === 0) {
      return `background: ${container.containerBackground};`;
    } else if (container.container_background_type === 1) {
      return `background: url('${container.containerBackground}'); background-size: cover; background-position: top;`;
    }
    return '';
  }

  setContainerWidth(container) {
    if (container.max_width !== null) {
      return `max-width: ${container.max_width}px;`;
    }
    return '';
  }

  setContainerPadding(container) {
    if (container.padding !== null) {
      return `padding: ${container.padding}px;`;
    }
    return '';
  }

  setFieldSetClassAttribute(container, id) {
    return 'class="fieldset' + id.split('-')[0] +'"';
  }

  setContainerFieldSetBodyFlexOptions(container) {
    return `container-direction-${container.layout_direction} container-layout-${container.layout_direction_alignment}-${container.layout_perpendicular_alignment}`;
  }

  public generateAddButtonMultipleInputTemplate(ctx, temp, component, values) {
    let template = '';
    const max = component.max_multivalued_options;
    if (max !== undefined && max != null && max > 0) {
      if (values && values.length < max){
        template += '\n  <tr>\n    <td colspan="2">\n      <button style="border: 1px solid; border-color: #0000002e; border-radius: 5px; display: flex;" class="btn btn-primary formio-button-add-another" ref="addButton">' +
        ((temp =  ((ctx.t(ctx.component.textAddButton))) == null || (ctx.t(ctx.component.textAddButton)) == "") ? 
        '<span class="material-icons">add</span> <span style="margin-top: 2px;">  Adicionar</span>' : temp) +
        '</button>\n    </td>\n  </tr>\n  ';
      }
    } else {
      template += '\n  <tr>\n    <td colspan="2">\n      <button style="border: 1px solid; border-color: #0000002e; border-radius: 5px; display: flex;" class="btn btn-primary formio-button-add-another" ref="addButton">' +
      ((temp =  ((ctx.t(ctx.component.textAddButton))) == null || (ctx.t(ctx.component.textAddButton)) == "") ? 
      '<span class="material-icons">add</span> <span style="margin-top: 2px;">  Adicionar</span>' : temp) +
      '</button>\n    </td>\n  </tr>\n  ';
    }
    return template;
  }

  public generateRemoveButtonMultipleInputTemplate(ctx, temp, component, values) {
    let template = '';
    const min = component.min_multivalued_options;
    if (min !== undefined && min != null) {
      if (values && values.length > min) {
        template +=   '\n  <td style="vertical-align: inherit;">\n    <button style="border: 1px solid; border-color: #0000002e; border-radius: 5px; display:flex;margin:auto" type="button" class="btn btn-secondary" ref="removeRow">\n <span style="color:#000000; margin:auto" class="material-icons">delete</span>\n    </button>\n  </td>\n  ';
      }
    } else {
      template += '\n  <td style="vertical-align: inherit;">\n    <button style="border: 1px solid; border-color: #0000002e; border-radius: 5px; display:flex;margin:auto" type="button" class="btn btn-secondary" ref="removeRow">\n <span style="color:#000000; margin:auto" class="material-icons">delete</span>\n    </button>\n  </td>\n  ';
    }
    return template;
  }
  public setTemplates() {
    let id = uuid.v4();
    // Templates.defaultTemplates.webform.form = (ctx) => {
    //   var temp, template = '';
    //   template += '<form autocomplete="off" class="' +
    //   ((temp = (ctx.classes)) == null ? '' : temp) +
    //   '" ref="webform" novalidate>' +
    //   ((temp = (ctx.children)) == null ? '' : temp) +
    //   '</form>\n';
    //   return template
    // }

    Templates.defaultTemplates.field.form = (ctx) => {
      var temp, template = '', join = Array.prototype.join;
      function print() { template += join.call(arguments, '') }

      if (!ctx.label.hidden && ctx.label.labelPosition !== 'bottom') { ;
      template += '\n  ' +
      ((temp = ( ctx.labelMarkup )) == null ? '' : temp) +
      '\n';
      } ;
      template += '\n\n';
      if (ctx.label.hidden && ctx.label.className && ctx.component.validate && ctx.component.validate.required) { ;
      template += '\n  <label class="' +
      ((temp = (ctx.label.className)) == null ? '' : temp) +
      '"></label>\n';
      } ;
      template += '\n\n' +
      ((temp = (ctx.element)) == null ? '' : temp) +
      '\n\n';
      if (!ctx.label.hidden && ctx.label.labelPosition === 'bottom') { ;
      template += '\n  ' +
      ((temp = ( ctx.labelMarkup )) == null ? '' : temp) +
      '\n';
      } ;
      template += '\n';
      if (ctx.component.description) { ;
      template += '\n  <div class="form-text text-muted">' +
      ((temp = (ctx.t(ctx.component.description))) == null ? '' : temp) +
      '</div>\n';
      } ;
      template += '\n';
      return template
    };

    Templates.defaultTemplates.file.form = (ctx) => {
      var temp, template = '', join = Array.prototype.join;
      function print() { template += join.call(arguments, '') }

      if (!ctx.self.imageUpload) { ;
      template += '\n  <ul class="list-group list-group-striped">\n    <li class="list-group-item list-group-header hidden-xs hidden-sm">\n      <div class="row">\n        ';
      if (!ctx.disabled) { ;
      template += '\n          <div class="col-md-1"></div>\n        ';
      } ;
      template += '\n        <div class="col-md-';
      if (ctx.self.hasTypes) { ;
      template += '7';
      } else { ;
      template += '9';
      } ;
      template += '"><strong>' +
      ((temp = (ctx.t('File Name'))) == null ? '' : temp) +
      '</strong></div>\n        <div class="col-md-2"><strong>' +
      ((temp = (ctx.t('Size'))) == null ? '' : temp) +
      '</strong></div>\n        ';
      if (ctx.self.hasTypes) { ;
      template += '\n          <div class="col-md-2"><strong>' +
      ((temp = (ctx.t('Type'))) == null ? '' : temp) +
      '</strong></div>\n        ';
      } ;
      template += '\n      </div>\n    </li>\n    ';
      ctx.files.forEach(function(file) { ;
      template += '\n      <li class="list-group-item">\n        <div class="row">\n          ';
      if (!ctx.disabled) { ;
      template += '\n            <div class="col-md-1"><i class="' +
      ((temp = (ctx.iconClass('remove'))) == null ? '' : temp) +
      '" ref="removeLink"></i></div>\n          ';
      } ;
      template += '\n          <div class="col-md-';
      if (ctx.self.hasTypes) { ;
      template += '7';
      } else { ;
      template += '9';
      } ;
      template += '">\n            ';
      if (ctx.component.uploadOnly) { ;
      template += '\n              ' +
      ((temp = (file.originalName || file.name)) == null ? '' : temp) +
      '\n            ';
      } else { ;
      template += '\n              <a href="' +
      ((temp = (file.url || '#')) == null ? '' : temp) +
      '" target="_blank" ref="fileLink">' +
      ((temp = (file.originalName || file.name)) == null ? '' : temp) +
      '</a>\n            ';
      } ;
      template += '\n          </div>\n          <div class="col-md-2">' +
      ((temp = (ctx.fileSize(file.size))) == null ? '' : temp) +
      '</div>\n          ';
      if (ctx.self.hasTypes && !ctx.disabled) { ;
      template += '\n            <div class="col-md-2">\n              <select class="file-type" ref="fileType">\n                ';
      ctx.component.fileTypes.map(function(type) { ;
      template += '\n                  <option class="test" value="' +
      ((temp = ( type.value )) == null ? '' : temp) +
      '" ';
      if (type.label === file.fileType) { ;
      template += 'selected="selected"';
      } ;
      template += '>' +
      ((temp = ( type.label )) == null ? '' : temp) +
      '</option>\n                ';
      }); ;
      template += '\n              </select>\n            </div>\n          ';
      } ;
      template += '\n          ';
      if (ctx.self.hasTypes && ctx.disabled) { ;
      template += '\n          <div class="col-md-2">' +
      ((temp = (file.fileType)) == null ? '' : temp) +
      '</div>\n          ';
      } ;
      template += '\n        </div>\n      </li>\n    ';
      }) ;
      template += '\n  </ul>\n';
      } else { ;
      template += '\n  <div>\n    ';
      ctx.files.forEach(function(file) { ;
      template += '\n      <div>\n        <span>\n          <img ref="fileImage" src="" alt="' +
      ((temp = (file.originalName || file.name)) == null ? '' : temp) +
      '" style="width:' +
      ((temp = (ctx.component.imageSize)) == null ? '' : temp) +
      'px">\n          ';
      if (!ctx.disabled) { ;
      template += '\n            <i class="' +
      ((temp = (ctx.iconClass('remove'))) == null ? '' : temp) +
      '" ref="removeLink"></i>\n          ';
      } ;
      template += '\n        </span>\n      </div>\n    ';
      }) ;
      template += '\n  </div>\n';
      } ;
      template += '\n';
      if (!ctx.disabled && (ctx.component.multiple || !ctx.files.length)) { ;
      template += '\n  ';
      if (ctx.self.useWebViewCamera) { ;
      template += '\n    <div class="fileSelector">\n      <button class="btn btn-primary" ref="galleryButton"><i class="fa fa-book"></i> ' +
      ((temp = (ctx.t('Gallery'))) == null ? '' : temp) +
      '</button>\n      <button class="btn btn-primary" ref="cameraButton"><i class="fa fa-camera"></i> ' +
      ((temp = (ctx.t('Camera'))) == null ? '' : temp) +
      '</button>\n    </div>\n  ';
      } else if (!ctx.self.cameraMode) { ;
      template += '\n    <div class="fileSelector" ref="fileDrop">\n      <i class="' +
      ((temp = (ctx.iconClass('cloud-upload'))) == null ? '' : temp) +
      '"></i> ' +
      ((temp = (ctx.t('Drop files to attach,'))) == null ? '' : temp) +
      '\n        ';
      if (ctx.self.imageUpload) { ;
      template += '\n          <a href="#" ref="toggleCameraMode"><i class="fa fa-camera"></i> ' +
      ((temp = (ctx.t('Use Camera,'))) == null ? '' : temp) +
      '</a>\n        ';
      } ;
      template += '\n        ' +
      ((temp = (ctx.t('or'))) == null ? '' : temp) +
      ' <a href="#" ref="fileBrowse" class="browse">' +
      ((temp = (ctx.t('browse'))) == null ? '' : temp) +
      '</a>\n    </div>\n  ';
      } else { ;
      template += '\n    <div>\n      <video class="video" autoplay="true" ref="videoPlayer"></video>\n    </div>\n    <button class="btn btn-primary" ref="takePictureButton"><i class="fa fa-camera"></i> ' +
      ((temp = (ctx.t('Take Picture'))) == null ? '' : temp) +
      '</button>\n    <button class="btn btn-primary" ref="toggleCameraMode">' +
      ((temp = (ctx.t('Switch to file upload'))) == null ? '' : temp) +
      '</button>\n  ';
      } ;
      template += '\n';
      } ;
      template += '\n';
      ctx.statuses.forEach(function(status) { ;
      template += '\n  <div class="file ' +
      ((temp = (ctx.statuses.status === 'error' ? ' has-error' : '')) == null ? '' : temp) +
      '">\n    <div class="row">\n      <div class="fileName col-form-label col-sm-10">' +
      ((temp = (status.originalName)) == null ? '' : temp) +
      ' <i class="' +
      ((temp = (ctx.iconClass('remove'))) == null ? '' : temp) +
      '" ref="fileStatusRemove"></i></div>\n      <div class="fileSize col-form-label col-sm-2 text-right">' +
      ((temp = (ctx.fileSize(status.size))) == null ? '' : temp) +
      '</div>\n    </div>\n    <div class="row">\n      <div class="col-sm-12">\n        ';
      if (status.status === 'progress') { ;
      template += '\n          <div class="progress">\n            <div class="progress-bar" role="progressbar" aria-valuenow="' +
      ((temp = (status.progress)) == null ? '' : temp) +
      '" aria-valuemin="0" aria-valuemax="100" style="width: ' +
      ((temp = (status.progress)) == null ? '' : temp) +
      '%">\n              <span class="sr-only">' +
      ((temp = (status.progress)) == null ? '' : temp) +
      '% ' +
      ((temp = (ctx.t('Complete'))) == null ? '' : temp) +
      '</span>\n            </div>\n          </div>\n        ';
      } else { ;
      template += '\n          <div class="bg-' +
      ((temp = (status.status)) == null ? '' : temp) +
      '">' +
      ((temp = (ctx.t(status.message))) == null ? '' : temp) +
      '</div>\n        ';
      } ;
      template += '\n      </div>\n    </div>\n  </div>\n';
      }) ;
      template += '\n';
      if (!ctx.component.storage || ctx.support.hasWarning) { ;
      template += '\n  <div class="alert alert-warning">\n    ';
      if (!ctx.component.storage) { ;
      template += '\n      <p>' +
      ((temp = (ctx.t('No storage has been set for this field. File uploads are disabled until storage is set up.'))) == null ? '' : temp) +
      '</p>\n    ';
      } ;
      template += '\n    ';
      if (!ctx.support.filereader) { ;
      template += '\n      <p>' +
      ((temp = (ctx.t('File API & FileReader API not supported.'))) == null ? '' : temp) +
      '</p>\n    ';
      } ;
      template += '\n    ';
      if (!ctx.support.formdata) { ;
      template += '\n      <p>' +
      ((temp = (ctx.t("XHR2's FormData is not supported."))) == null ? '' : temp) +
      '</p>\n    ';
      } ;
      template += '\n    ';
      if (!ctx.support.progress) { ;
      template += '\n      <p>' +
      ((temp = (ctx.t("XHR2's upload progress isn't supported."))) == null ? '' : temp) +
      '</p>\n    ';
      } ;
      template += '\n  </div>\n';
      } ;
      template += '\n';
      return template
    }

    Templates.defaultTemplates.button.form = (ctx) => {
      ctx.component.custom = `window.formFunctions.submit(data, component, form);`;
      ctx.component.action = `custom`;
      // ctx.component.action = `submit`;
      let temp;
      let template = '',
      join = Array.prototype.join;
      function print() { template += join.call('') }
      template += '<' +
      ((temp = (ctx.input.type)) == null ? '' : temp) +
      '\n  ref="button"\n  ';

      template += `style="border-radius: 5px; white-space: normal; display: inline-flex;color:
      ${((temp = (ctx.input.component.internalColor)) == null ? 'black': temp)};
      background-color: ${((temp = (ctx.input.component.externalColor)) == null ? 'white': temp)};
      "`;

      for (var attr in ctx.input.attr) { ;
      if(attr === 'class'){
        template +=`\n class="${((temp = (ctx.input.component.style)) == null ? 'btn': 'ps-button btn ' + temp) + ' '+ ((temp = (ctx.input.attr[attr])) == null ? '' : temp)}"\n`
        ;
      } else {
        template += '\n  ' +
        ((temp = (attr)) == null ? '' : temp) +
        '="' +
        ((temp = (ctx.input.attr[attr])) == null ? '' : temp) +
        '"\n  ';
      }
      } ;

      template += '\n>\n';

      if (ctx.component.leftIcon) { ;
      template += `<span style="font-size: 19px; color:
      ${((temp = (ctx.input.component.internalColor)) == null ? 'black': temp)}
      " class="material-icons">${((temp = (ctx.component.leftIcon)) == null ? '' : temp)}</span>&nbsp;`
      } ;

      template += '\n' +
      ((temp = (ctx.input.content)) == null ? '' : temp) +
      '\n';
      if (ctx.component.tooltip) { ;

      template += '\n  <i ref="tooltip" class="' +
      ((temp = (ctx.iconClass('question-sign'))) == null ? '' : temp) +
      ' text-muted"></i>\n';
      } ;
      template += '\n';

      if (ctx.component.rightIcon) { ;
        template += `&nbsp<span style="font-size: 19px; color:
        ${((temp = (ctx.input.component.internalColor)) == null ? 'black': temp)}
        " class="material-icons">${((temp = (ctx.component.rightIcon)) == null ? '' : temp)}</span>`
      } ;

      template += '\n</' +
      ((temp = (ctx.input.type)) == null ? '' : temp) +
      `>\n<div ref="buttonMessageContainer">\n  <span  class="help-block" ref="buttonMessage"></span>\n</div>\n`;
      return template
    };

    Templates.defaultTemplates.html.form = (ctx) => {
        id = uuid.v4();
        var temp, template = '', join = Array.prototype.join;
        function print() { template += join.call(arguments, '') }
        template += '<div  class="' + 'html' + id.split('-')[0] + '"  ref="html" >\n'
        template += '<' +
        ((temp = (ctx.tag)) == null ? '' : temp) +
        ((temp = ( ctx.component.className )) === '' ? '' : ' class=" ' + temp + '"')
        ctx.attrs.forEach(function(attr) {
          template += '\n    ' +
          ((temp = (attr.attr)) == null ? '' : temp) +
          '="' +
          ((temp = (attr.value)) == null ? '' : temp) +
          '"\n  ';
        }) ;

        template += '\n>' +
        ((temp = (ctx.content)) == null ? '' : temp);
        if (!ctx.singleTags || ctx.singleTags.indexOf(ctx.tag) === -1) {
          template += '</' +
          ((temp = (ctx.tag)) == null ? '' : temp) +
          '>';
        } ;
        template += '\n';

        template += '</div>\n'

        template = template.replace(/\<style(.[^\<]*)\<\/style\>/gim, (val) => {
          val = val.replace(/\<style(.[^\<]*)>/gim, '');
          val = val.replace(/\<style>/gim, '');
          val = val.replace(/\<\/style\>/gim, '');
          val = val.replace(/\r?\n|\r/gim, '');
          val = val.trim();
          const rules = CSSOM.parse(val);
          rules.cssRules.forEach(rule => {
            const selectors = rule.selectorText.split(',');
            let selectorText = '';
            selectors.forEach((selector, i) => {
                return selectorText += '.html' + id.split('-')[0]+ ' ' + selector + ',';
            });
            selectorText = selectorText.substring(0,(selectorText.length - 1));
            rule.selectorText = selectorText;
          });
          val = rules.toString();
          return '<style>' + val + '</style>';
        });
        template = template.replace(/\<style>(?!(.[^\<]*)\<\/style\>)/gim, '');
        
        // configurar o form renderer nas renderOptions true/false para saber se vai pegar o codigo para executar os scripts
        if(ctx.options.executeScripts && ctx.tag === 'script'){
          const interval =  setInterval(function(){
            const element =  ctx.instance.element;
            if(element){
                const fragment = toHtml(template);
                element.innerHTML = '';
                element.appendChild(fragment);
                clearInterval(interval);
            }
          }, 1000);
        }
        return template;
    }

    Templates.defaultTemplates.multiValueRow.form = (ctx) => {
      var temp, template = '', join = Array.prototype.join;
      function print() { template += join.call(arguments, '') }
      template += '<tr ref="row">\n  <td>\n    ' +
      ((temp = (ctx.element)) == null ? '' : temp) +
      '\n  </td>\n  ';
      if (!ctx.disabled) { ;
        template += this.generateRemoveButtonMultipleInputTemplate(ctx, temp, ctx.component, ctx.value);
      } ;
      template += '\n</tr>\n';
      return template
    }

    Templates.defaultTemplates.multiValueTable.form = (ctx) => {
      var temp, template = '', join = Array.prototype.join;
      function print() { template += join.call(arguments, '') }
      template += '<table class="table table-bordered">\n  <tbody>\n  ' +
      ((temp = (ctx.rows)) == null ? '' : temp) +
      '\n  ';
      if (!ctx.disabled) { ;
        template += this.generateAddButtonMultipleInputTemplate(ctx, temp, ctx.component, ctx.value);
      } ;
      template += '\n  </tbody>\n</table>\n';

      return template
    }

    Templates.defaultTemplates.label.form = (ctx) => {
      var temp, template = '', join = Array.prototype.join;
      function print() { template += join.call(arguments, '') }
      template += '<label class="col-form-label ' +
      ((temp = (ctx.label.className)) == null ? '' : temp) +
      '">\n  ' +
      ((temp = ( ctx.t(ctx.component.label) )) == null ? '' : temp) +
      '\n  ';
      if (ctx.component.tooltip) { ;
      template += '\n    <i ref="tooltip" class="material-icons text-muted ps-defalt-icon-size">help</i>\n  ';
      } ;
      template += '\n</label>\n';
      return template
    }

    Templates.defaultTemplates.checkbox.form = (ctx) => {
      var temp, template = '',join = Array.prototype.join;
      function print() {
        template += join.call(arguments, '');
      }
      template += '<div class="form-check checkbox">\n  <label class="' + ((temp = ctx.input.labelClass) == null ? '' : temp) + ' form-check-label">\n    <' + ((temp = ctx.input.type) == null ? '' : temp) + '\n      ref="input"\n      ';
      for (var attr in ctx.input.attr) {
        template += '\n      ' + ((temp = attr) == null ? '' : temp) + '="' + ((temp = ctx.input.attr[attr]) == null ? '' : temp) + '"\n      ';
      };
      template += '\n      '
      if (ctx.checked) {
        template += 'checked=true';
      };
      template += '\n      aria-required="' + ((temp = ctx.component.validate?.required) == null ? '' : temp) + '"\n      ';
      if (ctx.component.description) {
        template += '\n      aria-describedby="d-' + ((temp = ctx.instance.id) == null ? '' : temp) + '-' + ((temp = ctx.component.key) == null ? '' : temp) + '"\n      ';
      };
      template += '\n      >\n    ';
      if (!ctx.self.labelIsHidden()) {
        template += '<span>' + ((temp = ctx.input.label) == null ? '' : temp) + '</span>';
      };
      template += '\n    ' + ((temp = ctx.input.content) == null ? '' : temp) + '\n    </' + ((temp = ctx.input.type) == null ? '' : temp) + '>\n  </label>\n  ';
      if (ctx.component.tooltip) {
        template += '\n    <i ref="tooltip" data-tooltip="' + ctx.component.tooltip.replaceAll(`"`, `'`) + '" class="material-icons text-muted ps-defalt-icon-size">help</i>\n  ';
      };
      template += '\n</div>\n';
      return template;
    };

    Templates.defaultTemplates.input.form = (ctx) => {
      var temp, template = '', join = Array.prototype.join;
      function print() { template += join.call(arguments, '') }

        if (ctx.component.prefix || ctx.component.suffix) { ;
      template += '\n<div class="input-group">\n';
        } ;
      template += '\n';
        if (ctx.component.prefix) { ;
      template += '\n<div class="input-group-prepend" ref="prefix">\n  <span class="input-group-text">\n    ' +
      ((temp = (ctx.component.prefix)) == null ? '' : temp) +
      '\n  </span>\n</div>\n';
        } ;
      template += '\n<' +
      ((temp = (ctx.input.type)) == null ? '' : temp) +
      '\n  ref="' +
      ((temp = (ctx.input.ref ? ctx.input.ref : 'input')) == null ? '' : temp) +
      '"\n  ';
        for (var attr in ctx.input.attr) { ;
      template += '\n  ' +
      ((temp = (attr)) == null ? '' : temp) +
      '="' +
      ((temp = (ctx.input.attr[attr])) == null ? '' : temp) +
      '"\n  ';
        } ;
      template += '\n>' +
      ((temp = (ctx.input.content)) == null ? '' : temp) +
      '</' +
      ((temp = (ctx.input.type)) == null ? '' : temp) +
      '>\n';
        if (ctx.component.showCharCount) { ;
      template += '\n<span class="text-muted pull-right" ref="charcount"></span>\n';
        } ;
      template += '\n';
        if (ctx.component.showWordCount) { ;
      template += '\n<span class="text-muted pull-right" ref="wordcount"></span>\n';
        } ;
      template += '\n';
        if (ctx.component.suffix) { ;
      template += '\n<div class="input-group-append" ref="suffix">\n  <span class="input-group-text">\n    ' +
      ((temp = (ctx.component.suffix)) == null ? '' : temp) +
      '\n  </span>\n</div>\n';
        } ;
      template += '\n';
        if (ctx.component.prefix || ctx.component.suffix) { ;
      template += '\n</div>\n';
        } ;
      template += '\n';
      return template
    }

    Templates.defaultTemplates.select.form = (ctx) => {
      var temp, template = '', join = Array.prototype.join;
      function print() { template += join.call(arguments, '') }
      template += '<select\n  ref="' +
      ((temp = (ctx.input.ref ? ctx.input.ref : 'selectContainer')) == null ? '' : temp) +
      '"\n  ' +
      ((temp = ( ctx.input.multiple ? 'multiple' : '' )) == null ? '' : temp) +
      '\n  ';
      for (var attr in ctx.input.attr) { ;
      template += '\n  ' +
      ((temp = (attr)) == null ? '' : temp) +
      '="' +
      ((temp = (ctx.input.attr[attr])) == null ? '' : temp) +
      '"\n  ';
      } ;
      template += '\n>' +
      ((temp = (ctx.selectOptions)) == null ? '' : temp) +
      '</select>\n<input type="text"\n       class="formio-select-autocomplete-input"\n       ref="autocompleteInput"\n       ';
      if (ctx.input.attr.autocomplete) { ;
      template += '\n       autocomplete="' +
      ((temp = (ctx.input.attr.autocomplete)) == null ? '' : temp) +
      '"\n       ';
      } ;
      template += '\n       tabindex="-1"\n/>\n';
      return template
    }

    Templates.defaultTemplates.columns.form = (ctx) => {
      var temp, template = '', join = Array.prototype.join;
      function print() { template += join.call(arguments, '') }
      ctx.component.columns.forEach(function(column, index) { ;
      template += '\n<div name="coluna" class="\n    col-' +
      ((temp = (column.size)) == null ? '' : temp) +
      '-' +
      ((temp = (column.width)) == null ? '' : temp) +
      '\n  " ref="' +
      ((temp = (ctx.columnKey)) == null ? '' : temp) +
      '">\n  ' +
      ((temp = (ctx.columnComponents[index])) == null ? '' : temp) +
      '\n</div>\n';
      }) ;
      template += '\n';
      return template
    }

    
    Templates.defaultTemplates.fieldset.form = (ctx) => {
      var temp, template = '', join = Array.prototype.join;
      function print() { template += join.call(arguments, '') }
      template += this.setContainerCustomCss(ctx, id);
      template += '<fieldset ';
      template += this.setFieldSetStyleAttribute(ctx.component);
      template += this.setFieldSetClassAttribute(ctx.component, id);
      template += '>\n  ';

      if (ctx.component.legend) { // construindo a tag legend que pode ter em um fieldSet que é coisa da biblioteca
        template += '\n  <legend ref="header" class="' +
        ((temp = (ctx.component.collapsible ? 'formio-clickable' : '')) == null ? '' : temp) +
        '">\n    ' +
        ((temp = (ctx.t(ctx.component.legend))) == null ? '' : temp) +
        '\n    ';
          if (ctx.component.tooltip) { ;
        template += '\n      <i ref="tooltip" class="' +
        ((temp = (ctx.iconClass('question-sign'))) == null ? '' : temp) +
        ' text-muted"></i>\n    ';
          } ;
        template += '\n  </legend>\n  ';
      }

      template += '\n  ';
      if (!ctx.collapsed) { 
        template += '\n  <div class="fieldset-body ';
        if (ctx.component.layout_direction !== null) {
          template += this.setContainerFieldSetBodyFlexOptions(ctx.component);
        }
        template += '" ref="' +
        ((temp = (ctx.nestedKey)) == null ? '' : temp) +
        '">\n    ' +
        ((temp = (ctx.children)) == null ? '' : temp) +
        '\n  </div>\n  ';
      }
      template += '\n</fieldset>\n';
      return template
    }

  }

}




